import React from 'react';

import { withStyles } from '@mui/styles';

import Cell from '../../common/Cell';

import { Grid, Table, Button, TableRow, TextField, TableBody, TableHead } from '@mui/material';

import ComponentWrapper from '../../common/ComponentWrapper';
import FullScreenDialog from '../../common/FullScreenDialog';

import CommonStyles from '../../common/CommonStyles';
import DictionaryPageStyles from './DictionaryPageStyles';

import DictionaryRow from './components/DictionaryRow';

const styles = {
  ...CommonStyles,
  ...DictionaryPageStyles,
};

class DictionaryPage extends ComponentWrapper {
  state = {
    dict: [],
    jel: {
      l10n: {},
    },
    searchTerm: '',
    searchResults: [],
    isTouched: false,
    openedDict: false,
    openedDictOld: null,
    serverMessage: '',
  };

  componentDidMount() {
    document.title="Dictionary | Milkyweb";

    this.getDictionary();
  }

  getDictionary = () => {
    this.get({
      url: '/get_jel?type=["l10n_dict"]',
      cb: (data) => {
        if (data.l10n_dict) {
          let formattedObjects = [];
          // eslint-disable-next-line
          const dict = data.l10n_dict[0].l10n;

          Object.keys(dict).forEach((key) => {
            const newObj = {
              name: key,
              en: dict[key].en,
              ru: dict[key].ru,
            };

            formattedObjects.push(newObj);
          });

          this.setState({ dict: formattedObjects, jel: data.l10n_dict[0] });
        }
      },
    });
  };

  onSearchInputChange = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    let searchResults = [];

    this.setState({ searchTerm, isTouched: true });

    if (searchTerm.length) {
      const { dict } = this.state;

      dict.forEach((item, itemIndex) => {
        const name = item.name.toLowerCase();
        const en = item.en.toLowerCase();
        const ru = item.ru.toLowerCase();

        if (name.includes(searchTerm) || en.includes(searchTerm) || ru.includes(searchTerm))
          searchResults.push(itemIndex);
      });
    }

    this.setState({ searchResults });
  };

  onVariableClick = (item) => {
    const itemCopy = Object.assign({}, item);
    const itemCopy2 = Object.assign({}, item);

    this.setState({ openedDict: itemCopy, openedDictOld: itemCopy2 });
  };

  onModalClose = () => {
    this.setState({ openedDict: false, serverMessage: '' });
  };

  onModalDictChange = (e) => {
    const { openedDict } = this.state;

    openedDict.name = e.target.value;

    this.setState({ openedDict, serverMessage: '' });
  };

  onModalDictLangChange = (lang, e) => {
    const { openedDict, openedDictOld } = this.state;

    openedDict[lang] = e.target.value;

    if (!openedDictOld || !openedDictOld.name) {
      this.generateKey(lang);
    }
    this.setState({ openedDict, serverMessage: '' });
  };

  addNewDict = () => {
    const openedDict = {
      name: '',
      ru: '',
      en: '',
    };

    const dictCopy = Object.assign({}, openedDict);

    this.setState({
      openedDict,
      openedDictOld: dictCopy,
    });
  };

  onSaveClick = () => {
    const { jel } = this.state;

    const key = this.state.openedDict.name;
    const en = this.state.openedDict.en || '';
    const ru = this.state.openedDict.ru || '';

    jel.l10n[key] = {
      en,
      ru,
    };

    this.postWithData({
      url: '/rest/upd_jel?type=l10n_dict',
      data: jel,
      cb: () => {
        this.getDictionary();

        this.setState({
          openedDict: false,
          openedDictOld: null,
        });
      },
    });
  };

  transliterate = (word) => {
    let answer = '',
      a = {};

    a['Ё'] = 'YO';
    a['Й'] = 'I';
    a['Ц'] = 'TS';
    a['У'] = 'U';
    a['К'] = 'K';
    a['Е'] = 'E';
    a['Н'] = 'N';
    a['Г'] = 'G';
    a['Ш'] = 'SH';
    a['Щ'] = 'SCH';
    a['З'] = 'Z';
    a['Х'] = 'H';
    a['Ъ'] = "'";
    a['ё'] = 'yo';
    a['й'] = 'i';
    a['ц'] = 'ts';
    a['у'] = 'u';
    a['к'] = 'k';
    a['е'] = 'e';
    a['н'] = 'n';
    a['г'] = 'g';
    a['ш'] = 'sh';
    a['щ'] = 'sch';
    a['з'] = 'z';
    a['х'] = 'h';
    a['ъ'] = "'";
    a['Ф'] = 'F';
    a['Ы'] = 'I';
    a['В'] = 'V';
    a['А'] = 'a';
    a['П'] = 'P';
    a['Р'] = 'R';
    a['О'] = 'O';
    a['Л'] = 'L';
    a['Д'] = 'D';
    a['Ж'] = 'ZH';
    a['Э'] = 'E';
    a['ф'] = 'f';
    a['ы'] = 'i';
    a['в'] = 'v';
    a['а'] = 'a';
    a['п'] = 'p';
    a['р'] = 'r';
    a['о'] = 'o';
    a['л'] = 'l';
    a['д'] = 'd';
    a['ж'] = 'zh';
    a['э'] = 'e';
    a['Я'] = 'Ya';
    a['Ч'] = 'CH';
    a['С'] = 'S';
    a['М'] = 'M';
    a['И'] = 'I';
    a['Т'] = 'T';
    a['Ь'] = "'";
    a['Б'] = 'B';
    a['Ю'] = 'YU';
    a['я'] = 'ya';
    a['ч'] = 'ch';
    a['с'] = 's';
    a['м'] = 'm';
    a['и'] = 'i';
    a['т'] = 't';
    a['ь'] = "'";
    a['б'] = 'b';
    a['ю'] = 'yu';

    for (let i in word) {
      if (word.hasOwnProperty(i)) {
        if (a[word[i]] === undefined) {
          answer += word[i];
        } else {
          answer += a[word[i]];
        }
      }
    }
    return answer;
  };

  generateKey = (lang) => {
    const { openedDict, dict } = this.state;

    let val = openedDict.en;

    if (lang === 'ru') {
      if (val === '') {
        val = this.transliterate(openedDict.ru);
      }
    }

    val = val.replace(/[^A-Za-z0-9 ]/g, '');
    val = val.toUpperCase();
    val = val.replace(/\n/g, ' ');

    let words = val.split(' ');
    let key = '';

    for (let i = 0; i < words.length && i < 5; i++) {
      if (i > 0) key += '_';
      key += words[i].trim();
    }

    if (dict[key]) key += '_' + 1;

    openedDict.name = key;

    this.setState({ openedDict });

    this.checkUniq();
  };

  checkUniq = () => {
    const { dict, openedDict } = this.state;

    let newKey = openedDict.name;
    if (dict[newKey]) {
      document.querySelector('.trnslt-modal input').style.backgroundColor = 'pink';
    } else {
      document.querySelector('.trnslt-modal input').style.backgroundColor = 'white';
    }
  };

  trimText = (text, textLength) => {
    return text && text.length > textLength ? `${text.substr(0, textLength)}...` : text;
  };

  render() {
    const { dict, searchResults, searchTerm, isTouched, openedDict } = this.state;

    const modalStyle = {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      content: {
        width: 800,
        position: 'relative',
        border: '1px solid #ccc',
        background: '#fff',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '4px',
        outline: 'none',
        padding: '20px',
      },
    };

    const { classes } = this.props;

    return (
      <div className={classes.trnslt}>
        <FullScreenDialog
          title="Edit"
          className="trnslt-modal"
          isOpen={Object.keys(openedDict).length ? true : false}
          style={modalStyle}
          onClose={this.onModalClose}
        >
          <TextField
            label="Name"
            fullWidth
            className={classes.mb20}
            onChange={this.onModalDictChange}
            value={openedDict.name}
          />

          <Grid className={classes.mb20} container spacing={2}>
            <Grid item xs={6}>
              <h3 className={classes.trnsltModalHeading3}>EN</h3>
              <TextField
                variant="filled"
                multiline
                fullWidth
                rows="30"
                value={openedDict.en}
                onChange={(e) => this.onModalDictLangChange('en', e)}
              />
            </Grid>

            <Grid item xs={6}>
              <h3 className={classes.trnsltModalHeading3}>RU</h3>
              <TextField
                variant="filled"
                multiline
                fullWidth
                rows="30"
                value={openedDict.ru}
                onChange={(e) => this.onModalDictLangChange('ru', e)}
              />
            </Grid>
          </Grid>

          <div className={`${classes.justifyEnd} ${classes.mb20}`}>
            <Button size="small" onClick={this.onSaveClick} color="primary" variant="contained">
              Save
            </Button>
          </div>

          {this.state.serverMessage && <div className={classes.trnsltSuccess}>{this.state.serverMessage}</div>}
        </FullScreenDialog>

        <div className={classes.trnslNewDictRow}>
          <Button size="small" onClick={this.addNewDict} color="primary" variant="contained">
            Add new
          </Button>
        </div>

        <TextField fullWidth className={classes.mb20} placeholder="Search" onChange={this.onSearchInputChange} />

        <h2 className={classes.trnsltHeading2}>All dictionaries: </h2>

        <Table className={`${classes.itemsTable} ${classes.mb20}`}>
          <TableHead>
            <TableRow>
              <Cell>Name</Cell>

              <Cell>EN</Cell>
              <Cell>RU</Cell>
            </TableRow>
          </TableHead>

          <TableBody>
            {searchTerm && searchResults.length
              ? searchResults.map((itemIndex) => {
                  const item = dict[itemIndex];

                  return (
                    <DictionaryRow
                      item={item}
                      key={itemIndex}
                      classes={classes}
                      trimText={this.trimText}
                      onVariableClick={this.onVariableClick}
                    />
                  );
                })
              : dict.map((item, itemIndex) => {
                  return (
                    <DictionaryRow
                      item={item}
                      key={itemIndex}
                      classes={classes}
                      trimText={this.trimText}
                      onVariableClick={this.onVariableClick}
                    />
                  );
                })}

            {!searchResults.length && searchTerm.length && isTouched ? (
              <TableRow>
                <Cell>
                  <span>Nothing found :(</span>
                </Cell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default withStyles(styles)(DictionaryPage);
